/**
 * Pluralise an all-caps stat label. "1 SHOPS" reads like a bug to a customer
 * looking at their own card.
 *
 * Only handles the regular -S case, which is all the dashboard stat line needs
 * (STAMP / COFFEE / SHOP). Pass an explicit plural for anything irregular.
 */
export function plural(count: number, singular: string, pluralForm?: string): string {
  if (count === 1) return singular;
  return pluralForm ?? `${singular}S`;
}

export default plural;
